import React, { Component, createRef  } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import GuidedNavigation from '../GuidedNavigation';
import _ from "lodash";
import Template from "./template";
import Link from "../../../../../../components/ZUILib/Link";
import commonUtil from "../../../../../../utils/commonUtil";
import Image from "../../../../../../components/ZUILib/Image/Image";
import ModalPopover from "../../../../../../components/ZUILib/ModalPopover";
import SelectionTab from "../../../../../../components/ZUILib/SelectionTab";
import ProgressBar from "../../../../../../components/ZUILib/ProgressBar";
import TextInput from "../../../../../../components/ZUILib/TextInput";
import InputButton from "../../../../../../components/ZUILib/InputButton";
import * as giftListActions from "../../actions";
import * as defaultConst from "../../../../../../utils/clientConstant";
import EmptyGiftListIndicator from "../EmptyGiftListIndicator";
import { Fragment } from "react";
import RegalosModalOverlay from "./components/RegalosModalOverlay";
import ChatMessageModal from "./components/ChatMessageModal";
import Warning2 from "../../../../../../components/Warning2";
import Warning from "../../../../../../components/Warning";

const { getMessagesService,addAgainGiftItem, addThankYouMessage, getTrackOrder, getAllMessagesService, getRegisteredGiftList, } =
  giftListActions;
const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];

class RegalosRecibidosContent extends Component {
  constructor(props) {
    super(props);
    this.sortType = "";
    this.giftData = "";
    this.scrollTargetRef = createRef();
    // this.state = { searchResultflag: false };
    this.state = {
      filteringParameters: this.props.filterParamsReceivedGift || [],
      sortingType: "",
      searchKeyword: "",
      selectedGiftItem: "",
      itemId: "",
      searchFlag: true,
      originalReceivedGiftList: _.isObject(props.originalReceivedGiftList)
        ? props.originalReceivedGiftList
        : { categoryList: [], filteringParameters: [], itemsInfo: [], links: [] },
      regalosModal: false,
      chatMessageModal: false,
      displaySelectedProductDetail: null,
      giftSectionType: null,
    };
    this.inititialReceivedItems = props.inititialReceivedItems || {};
  }
  progressBar = 0;
  searchedValue = "";
  giftItemID = "";
  newtoRead = "";
  stage1class = "titleOrder";
  stage2class = "titleOrder";
  stage3class = "titleOrder";
  stage4class = "titleOrder";


  componentDidMount() {
    this.props.getAllMessagesService(
      this.props.eventId,
    );
  }

  componentWillReceiveProps(nextProps) {
    const nextOriginalReceivedGiftList = nextProps.originalReceivedGiftList;
    const prevOriginalReceivedGiftList = this.props.originalReceivedGiftList;
    const originalReceivedGiftListDidChange = nextOriginalReceivedGiftList !== prevOriginalReceivedGiftList;
    if (originalReceivedGiftListDidChange) this.setState({ originalReceivedGiftList: nextOriginalReceivedGiftList });
  }

  sortGiftList = () => {
    this.sortType = this.sortType === "Descending" ? "Ascending" : "Descending";
    this.setState({ sortingType: this.sortType });
    this.props.getPaginatedReceivedGifts({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.sortType,
      filteringParameters: this.props.filterParamsReceivedGift || this.state.filteringParameters,
    });
    // return undefined;
  };

  categoryOptions(categoryOptionsInfo) {
    // eslint-disable-line class-methods-use-this
    const lookup = {};
    if (!categoryOptionsInfo || !categoryOptionsInfo.length) {
      return [];
    }
    const items = categoryOptionsInfo;
    const result = [];
    let i = 0;
    /* eslint-disable */
    for (let item; (item = items[i++]); ) {
      const categoryInfo = item.name;
      const categoryInfoId = item.id;
      if (!(categoryInfo in lookup)) {
        lookup[categoryInfo] = 1;
        // lookup[categoryInfo] = 1;
        result.push({
          id: categoryInfoId,
          value: categoryInfo,
          labelResourceId: categoryInfo,
          disabled: false,
        });
      }
    }
    /* eslint-enable */
    return result;
  }

  clearSearch = () => {
    this.setState({ searchKeyword: "", searchFlag: true });
    this.props.getPaginatedReceivedGifts({
      priceOrder: this.state.sortingType,
      filteringParameters: this.props.filterParamsReceivedGift || this.state.filteringParameters,
    });
    document.getElementById("searchAreaForReceivedGifts").value = "";
  };
  onSearchAreaKeyUpForReceivedGifts = (e) => {
    if (e.keyCode === 13) {
      // Service Call
      this.setState({
        searchKeyword: this.searchGift.getValue(),
        searchFlag: false,
      });
      this.props.getPaginatedReceivedGifts({
        searchKeyword: this.searchGift.getValue(),
        priceOrder: this.state.sortingType,
        filteringParameters: this.props.filterParamsReceivedGift || this.state.filteringParameters,
      });
      this.searchedValue = this.searchGift.getValue();
    }
    if (!e.target.value.length) {
      this.setState({ searchFlag: true });
      this.props.getPaginatedReceivedGifts({
        priceOrder: this.state.sortingType,
        filteringParameters: this.props.filterParamsReceivedGift || this.state.filteringParameters,
      });
    }
  };

  onClickSearchResult = () => {
    this.setState({
      searchKeyword: this.searchGift.getValue(),
      searchFlag: false,
    });
    this.props.getPaginatedReceivedGifts({
      searchKeyword: this.searchGift.getValue(),
      priceOrder: this.state.sortingType,
      filteringParameters: this.props.filterParamsReceivedGift || this.state.filteringParameters,
    });
    this.searchedValue = this.searchGift.getValue();
  };

  handleFilter(type, value) {
    // const filteringParameters = this.state.filteringParameters;
    let fpType = "";
    let isRemove = false;
    if (type === "deliveryMode") {
      fpType = "deliveryMode";
    } else if (type === "category") {
      fpType = "category";
    } else if (type === "message") {
      fpType = "message";
    } else if (type === "bonusApplicable") {
      fpType = "bonusApplicable";
    }
    if (value === undefined) {
      isRemove = true;
    }
    this.updateFilterParams(fpType, value, isRemove);
  }

  updateFilterParams(fpType, value, isRemove) {
    const filteringParameters = this.state.filteringParameters;
    if (isRemove) {
      for (let i = 0; i < filteringParameters.length; i++) {
        if (filteringParameters[i].type === fpType) {
          filteringParameters.splice(i, 1);
        }
      }
    } else {
      const type = _.find(filteringParameters, { type: fpType });
      if (type) {
        type.value = value;
      } else {
        filteringParameters.push({ type: fpType, value });
      }
    }
    this.setState({
      filteringParameters,
    });
    this.props.getPaginatedReceivedGifts({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.state.sortingType,
      filteringParameters,
    });
  }

  trackOrder = (giftDetail) => {
    this.giftData = giftDetail;
    // this.props.getTrackOrder(this.props.eventId, giftDetail.purchaseItemId, '20237586');
    // this.props.getTrackOrder(this.props.eventId, '100008', '20237585');
    this.props
      .getTrackOrder(
        this.props.eventId,
        giftDetail.purchaseItemId,
        giftDetail.pedidoNo
      )
      .then((response) => {
        if (response.status === "success") {
          this.trackerModal.handleShow();
        } else {
          this.failureTrackingModal.handleShow();
        }
      });
  };
  showProductDetail = (giftDetail) => {
    if (giftDetail.messageInfo === "replied") {
      this.props
        .getMessagesService(this.props.eventId, giftDetail.purchaseItemId)
        .then((response) => {
          if (response.status === "success") {
            if (
              response &&
              response.messageInfo &&
              response.messageInfo.customerMsg &&
              response.messageInfo.customMsg !== ""
            ) {
              this.modalforReplied.handleShow();
            } else {
              this.noneRepliedModal.handleShow();
            }
          }
        })
        .catch((e) => {
          console.log(e);
        }); // console required
    }
    if (giftDetail.messageInfo === "none") {
      this.modalfornone.handleShow();
      this.setState({
        itemId: giftDetail.purchaseItemId,
      });
    }
    if (giftDetail.messageInfo === "opened") {
      this.props
        .getMessagesService(this.props.eventId, giftDetail.purchaseItemId)
        .then((response) => {
          if (response.status === "success") {
            this.setState({
              // messageDetails: response.messageInfo,
              itemId: giftDetail.purchaseItemId,
            });
          }
          this.modalforOpen.handleShow();
        })
        .catch((e) => {
          console.log(e);
        }); // console required
    }
    if (giftDetail.messageInfo === "new") {
      this.props
        .getMessagesService(this.props.eventId, giftDetail.purchaseItemId)
        .then((response) => {
          if (response.status === "success") {
            this.setState({
              // messageDetails: response.messageInfo,
              itemId: giftDetail.purchaseItemId,
            });
            this.newtoRead = giftDetail.purchaseItemId;
            this.setState({ ...this.state });
          }
          this.modalforNew.handleShow();
        })
        .catch((e) => {
          console.log(e);
        }); // console required
    }
    this.setState({
      selectedGiftItem: giftDetail,
    });
  };

  sendThankyouMessageNone = (itemId) => {
    const message = document.getElementById("SendMessageforNone").value;
    const guestEmail = document.getElementById("textGuestEmailNone").value;
    addThankYouMessage(
      this.props.eventId,
      itemId,
      message,
      guestEmail || ""
    ).then((response) => {
      if (response.body.status === "success") {
        this.props.getRecievedGiftList(
          "",
          this.state.sortingType,
          this.state.filteringParameters
        );
        this.setState({ ...this.state });
        document.getElementById("SendMessageforNone").value = "";
        document.getElementById("textGuestNameNone").value = "";
        document.getElementById("textGuestEmailNone").value = "";
      }
    });
    this.modalfornone.handleHide();
  };
  sendThankyouMessageNew = (itemId) => {
    const message = document.getElementById("textArea1").value;
    const guestEmail =
      document.getElementById("textGuestEmailNew") &&
      document.getElementById("textGuestEmailNew").value;
    addThankYouMessage(
      this.props.eventId,
      itemId,
      message,
      guestEmail || ""
    ).then((response) => {
      if (response.body.status === "success") {
        // if (itemId.messageInfo === 'opened' || itemId.messageInfo === 'new') {
        this.giftItemID = itemId.purchaseItemId;
        this.newtoRead = "";
        // }
        this.setState({ ...this.state });
        this.props.getRecievedGiftList(
          "",
          this.state.sortingType,
          this.state.filteringParameters
        );
        document.getElementById("textArea1").value = "";
        if (document.getElementById("textGuestNameNew"))
          document.getElementById("textGuestNameNew").value = "";
        if (document.getElementById("textGuestEmailNew"))
          document.getElementById("textGuestEmailNew").value = "";
      }
    });

    this.modalforNew.handleHide();
  };

  sendThankyouMessageOpen = (itemId) => {
    const message = document.getElementById("sendMessage").value;
    const guestEmail =
      document.getElementById("textGuestEmailOpen") &&
      document.getElementById("textGuestEmailOpen").value;
    addThankYouMessage(
      this.props.eventId,
      itemId,
      message,
      guestEmail || ""
    ).then((response) => {
      if (response.body.status === "success") {
        // if (itemId.messageInfo === 'opened' || itemId.messageInfo === 'new') {
        this.giftItemID = itemId.purchaseItemId;
        this.newtoRead = "";
        // }
        this.setState({ ...this.state });
        this.props.getRecievedGiftList(
          "",
          this.state.sortingType,
          this.state.filteringParameters
        );
        document.getElementById("sendMessage").value = "";
        if (document.getElementById("textGuestNameOpen"))
          document.getElementById("textGuestNameOpen").value = "";
        if (document.getElementById("textGuestEmailOpen"))
          document.getElementById("textGuestEmailOpen").value = "";
      }
    });

    this.modalforOpen.handleHide();
  };
  handleCloseforRepliedModal = () => {
    this.modalforReplied.handleHide();
  };
  handleCloseforNewModal = () => {
    this.modalforNew.handleHide();
    document.getElementById("textArea1").value = "";
    if (document.getElementById("textGuestNameNew"))
      document.getElementById("textGuestNameNew").value = "";
    if (document.getElementById("textGuestEmailNew"))
      document.getElementById("textGuestEmailNew").value = "";
  };
  handleCloseforOpenModal = () => {
    this.modalforOpen.handleHide();
    document.getElementById("sendMessage").value = "";
    if (document.getElementById("textGuestNameOpen"))
      document.getElementById("textGuestNameOpen").value = "";
    if (document.getElementById("textGuestEmailOpen"))
      document.getElementById("textGuestEmailOpen").value = "";
  };
  handleCloseforNoneModal = () => {
    this.modalfornone.handleHide();
    document.getElementById("textGuestNameNone").value = "";
    document.getElementById("textGuestEmailNone").value = "";
    document.getElementById("SendMessageforNone").value = "";
  };
  dismissDelete = () => {
    this.failureTrackingModal.handleHide();
  };

  hideModalOverlay = () => {
    this.setState({
      regalosModal: false,
      displaySelectedProductDetail: null,
      giftSectionType: null,
    })
    document.body.classList.remove('body-no-scroll');
  }

  showModalOverlay = (giftDetail, giftSection) => {
    this.setState({
      displaySelectedProductDetail: giftDetail,
      giftSectionType: giftSection,
      regalosModal: true
    })
  }

  hideChatModalOverlay = () => {
    this.setState({
      chatMessageModal: false,
      displaySelectedProductDetail: null,
      giftSectionType: null,
    })
  }

  showChatModalOverlay = () => {
    this.setState({
      chatMessageModal: true
    })
  }

  handleChatBackModalOverlay = () => {
    this.setState({
      chatMessageModal: false,
      regalosModal: true
    })
  }

  onReplyMessageClick = (giftDetail, giftSection) => {
    document.body.classList.remove('body-no-scroll');
    this.setState({
      chatMessageModal: true,
      regalosModal: false,
      displaySelectedProductDetail: giftDetail,
      giftSectionType: giftSection,
    })
  }


    addAgain = (skuId,addAgainAlert) => {
    addAgainGiftItem(this.props.eventId, skuId)
      .then((response) => {
        if (response.body.status?.status === "success") {
          this.props.getRegisteredGiftList(this.props.eventId, this.props.registeredGiftListPriceOrder, "", "");
          // this.warning.setMessage(
          //   commonUtil.getLabel(
          //     this.props.lables.EventAdminPage,
          //     "adminpage.regalosrecibidos.gift.added.success.message"
          //   )
          // );     
          this.props.setAddAgainAlert(true); 
          this.props.showMessagePopUp(true,false,true,commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.gift.addagain.success.message"
            ));
        } else {
          // this.errorMessage.setMessage(
            this.props.showMessagePopUp(false,false,true,commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.add.again.failure.message"
            )
          );
        }

        this.hideModalOverlay();

        if (this.scrollTargetRef.current) {
          this.scrollTargetRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
        
      })
      .catch((e) => {
        console.log(e);
        if(e.body && e.body.detail){
          this.props.showMessagePopUp(false,false,true,e.body.detail);
        }
      }); // console required
  };

  render() {
    const {
       itemsInfo: receivedGifts = [],
      filteringParameters,
      itemsCount: totalReceivedGifts,
      currentPage: currentlyViewedPage,
      recordsPerPage,
      searchKeyword,
    } = this.state.originalReceivedGiftList;
    const totalRecordsShowed = ((Number(currentlyViewedPage) - 1) * recordsPerPage) + receivedGifts.length;
    const listIsEmpty = _.isNumber(Number(totalReceivedGifts)) && Number(totalReceivedGifts) <= 0;
    const currentBrandColors = commonUtil.getCurrentBrandColors();

    const lables = this.props.lables;
    let receivedGiftList = [];
    const { receivedItemsInfo, filterParamsReceivedGift } = this.props;

    // if (this.props.receivedGiftList) {
    //   receivedGiftList = this.props.receivedGiftList;
    // }
    receivedGiftList =
      this.props.receivedGiftList && this.props.receivedGiftList.categoryList
        ? this.props.receivedGiftList
        : [];
    const receivedGift = receivedGiftList;
    // if (commonUtil.isEmpty(receivedItemsInfo)) {
    //   return null;
    // }
    const SelectionOptions1 = {
      options: [
        {
          option:
            lables &&
            commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label"
            ),
          value: "physical",
          disabled: false,
          selected: false,
        },
        {
          option:
            lables &&
            commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label"
            ),
          value: "electronic",
          disabled: false,
          selected: false,
        },
      ],
    };

    const MessageInfo = {
      options: [
        {
          // Todas los mensajes
          option:
            lables &&
            commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.regalosrecibidos.message.dropdown.received.label"
            ),
          value: "new",
          disabled: false,
          selected: false,
        },
        {
          option:
            lables &&
            commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.regalosrecibidos.message.dropdown.answered.label"
            ),
          value: "replied",
          disabled: false,
          selected: false,
        },
        {
          option:
            lables &&
            commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.regalosrecibidos.message.dropdown.notanswered.label"
            ),
          value: "opened",
          disabled: false,
          selected: false,
        },
        {
          option:
            lables &&
            commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.regalosrecibidos.message.dropdown.nomsg.label"
            ),
          value: "none",
          disabled: false,
          selected: false,
        },
      ],
    };
    const BonusInfo = {
      options: [
        {
          option:
            lables &&
            commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.regalosrecibidos.bonus.dropdown.applicable.label"
            ),
          value: "1",
          disabled: false,
          selected: false,
        },
        {
          option:
            lables &&
            commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.regalosrecibidos.bonus.dropdown.notapplicable.label"
            ),
          value: "0",
          disabled: false,
          selected: false,
        },
      ],
    };

    const CategoryOptions = {
      id: "categoryOptions",
      disable: false,
      defaultValue: "Todas las categorías",
      options:
        receivedGift && this.categoryOptions(this.props.recibidosCategory), // receivedGift && this.categoryOptions(receivedGift.categoryList),
    };
    const LinkJSON = {
      href: "javascript:void(0)",
      displayName: "",
    };


    const SortArticleButton = {
      type: 'button',
      id: 'sortArticle',
      style: 'mobileWhiteButton',
      value: this.state.sortingType === 'Ascending' ? commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.lowest.label'): commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.label'),
      disabled: !receivedItemsInfo,
      cssStyle: { opacity: receivedItemsInfo ? '100%' : '33%' },
      beforeIconClass: 'icon-swap',
      imageClass: commonUtil.getAssetURL() + '/images/expand_more.svg'
    };


    const LinkJSONPrice = {
      href: 'javascript:void(0);',
      displayName: '',
      onClickHandler: () => {
        const show = document.querySelector('#recieved .giftList-sort-modal').style.display;
        if (show === 'none') {
          document.querySelector('#recieved .giftList-sort-modal').style.display = 'block';
        } else {
          document.querySelector('#recieved .giftList-sort-modal').style.display = 'none';
        }
      },
    };

    const priceSorting = [{
      "id": 'Ascending',
      "value": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.ascending')
    }, {
      "id": 'Descending',
      "value": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.descending')
    }
    ]

    const handleSwitchRadio = (id) => {
      this.sortType = id,
        this.props.getPaginatedReceivedGifts({
          searchKeyword: this.state.searchKeyword,
          priceOrder: this.sortType,
          filteringParameters: this.props.filterParamsReceivedGift || this.state.filteringParameters,
        });
      this.props.getSorting(this.sortType);
      this.setState({ sortingType: this.sortType });
      document.querySelector('#recieved .giftList-sort-modal').style.display = 'none';
    }
    // image for tracker

    const imageAttrTracker = {
      id: "img1",
      src: this.giftData.imageURL,
      className: "imageTracing",
      altImg: commonUtil.getAssetURL() + "/images/guest/no-image.png",
    };
    const sendThankyouMessageNoneButton = {
      type: "button",
      value:
        lables &&
        commonUtil.getLabel(
          lables.EventAdminPage,
          "adminpage.regalosrecibidos.sendthankyou.button"
        ),
      style: "btnSecondarySpecial size-Full",
      onClickHandler: () => this.sendThankyouMessageNone(this.state.itemId),
      disabled: this.props.compareEventStatus(
        this.props.eventStatus,
        defaultConst.eventStatus.SUSPENDED
      )
        ? "disabled"
        : "",
    };
    const sendThankyouMessageNewButton = {
      type: "button",
      value:
        lables &&
        commonUtil.getLabel(
          lables.EventAdminPage,
          "adminpage.regalosrecibidos.sendthankyou.button"
        ),
      style: "btnSecondarySpecial size-Full",
      disabled: this.props.compareEventStatus(
        this.props.eventStatus,
        defaultConst.eventStatus.SUSPENDED
      )
        ? "disabled"
        : "",
      onClickHandler: () => this.sendThankyouMessageNew(this.state.itemId),
    };

    const sendThankyouMessageOpenButton = {
      type: "button",
      value:
        lables &&
        commonUtil.getLabel(
          lables.EventAdminPage,
          "adminpage.regalosrecibidos.sendthankyou.button"
        ),
      style: "btnSecondarySpecial size-Full",
      disabled: this.props.compareEventStatus(
        this.props.eventStatus,
        defaultConst.eventStatus.SUSPENDED
      )
        ? "disabled"
        : "",
      onClickHandler: () => this.sendThankyouMessageOpen(this.state.itemId),
    };

    const totalRecords = receivedGift.itemsCount;
    const loadedRecordCount = receivedItemsInfo ? receivedItemsInfo.length : 0;
    const currentPage = receivedGift.currentPage;
    const sortType = this.state.sortingType;
    this.props.setTotalRecordsForType(
      "tabrecieved",
      totalRecords,
      loadedRecordCount,
      sortType,
      currentPage
    );

    const html = receivedGifts.map((giftItem, index) => (
      <Template
        key={index}
        showProductDetail={this.showProductDetail}
        trackOrder={this.trackOrder}
        eventId={this.props.eventId}
        giftDetail={giftItem}
        eventType={this.props.eventType}
        eventStatus={this.props.eventStatus}
        eventContractInfo={this.props.eventInfo.contractInfo}
        compareEventStatus={this.props.compareEventStatus}
        lables={this.props.lables}
        giftItemID={this.giftItemID}
        newtoRead={this.newtoRead}
        selectedProductForPreview={this.showModalOverlay}
        addAgain = {this.addAgain}
        addAgainAlert={this.props.addAgainAlert}
        showMessagePopUp={this.props.showMessagePopUp}
      />
    ));

    const trackInfo = this.props.trackOrderInfo;
    const trackInfoPrice =
      trackInfo && trackInfo.orderTrackInfo && trackInfo.orderTrackInfo.price
        ? commonUtil.getCurrency(trackInfo.orderTrackInfo.price)
        : "";
    const trackOrderURL =
      trackInfo &&
      trackInfo.orderTrackInfo &&
      trackInfo.orderTrackInfo.tplRedirectionURL &&
      trackInfo.orderTrackInfo.trackingNumber
        ? trackInfo.orderTrackInfo.tplRedirectionURL +
          trackInfo.orderTrackInfo.trackingNumber
        : "";

    if (
      trackInfo &&
      trackInfo.orderTrackInfo &&
      trackInfo.orderTrackInfo.stageLevel
    ) {
      if (trackInfo.orderTrackInfo.stageLevel === "Stage1") {
        this.progressBar = 25;
        this.stage1class += " orderDelivered";
      } else if (trackInfo.orderTrackInfo.stageLevel === "Stage2") {
        this.progressBar = 50;
        this.stage1class += " orderDelivered";
        this.stage2class += " orderDelivered";
      } else if (trackInfo.orderTrackInfo.stageLevel === "Stage3") {
        this.progressBar = 75;
        this.stage1class += " orderDelivered";
        this.stage2class += " orderDelivered";
        this.stage3class += " orderDelivered";
      } else {
        this.progressBar = 100;
        this.stage1class += " orderDelivered";
        this.stage2class += " orderDelivered";
        this.stage3class += " orderDelivered";
        this.stage4class += " orderDelivered";
      }
    }

    return (
      <React.Fragment>
        {/* //commented changes for regalorecibidos alerts backup
        <div ref={this.scrollTargetRef}>
          <Warning2
            type="success"
            notSetToTop="true"
            style={{ backgroundColor: '#E7F8EC', marginBottom: '20px' }}
            text={this.warningMessage}
            ref={warning => this.warning = warning}
            onClose = {true}
          />
          <Warning
            type="error"
            text={this.errorMessage}
            ref={(errorMessage) => (this.errorMessage = errorMessage)}
            notSetToTop="true"
          />
        </div> */}
        <div className="row">
          {
            this.state.chatMessageModal && 
            <ChatMessageModal 
              handleBackModalOverlay={this.handleChatBackModalOverlay}
              hideModalOverlay={this.hideChatModalOverlay}
              giftSectionType={this.state.giftSectionType}
              selectedProduct={this.state.displaySelectedProductDetail}
              eventId={this.props.eventId}
              lables={this.props.lables}
              compareEventStatus={this.props.compareEventStatus}
              eventType={this.props.eventType}
              filterParams={this.props.filterParamsReceivedGift}
              sortingValue={this.state.sortingType}
              getRecievedGiftList={this.props.getRecievedGiftList}
              giftItemID={this.giftItemID}
              newtoRead={this.newtoRead}
              currentPage={currentPage}
            />
          }
          {
            this.state.regalosModal && 
            <RegalosModalOverlay 
             title={commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosrecibidos.modal.header.label')}
             onReplyMessageClick={this.onReplyMessageClick} 
             hideModalOverlay={this.hideModalOverlay} 
             giftSectionType={this.state.giftSectionType}
             selectedProduct={this.state.displaySelectedProductDetail}
             eventId={this.props.eventId}
             lables={this.props.lables}
             compareEventStatus={this.props.compareEventStatus}
             eventType={this.props.eventType}
             filterParams={this.props.filterParamsReceivedGift}
             handleMessagePDFDownload={this.props.handleMessagePDFDownload}
             sortingValue={this.state.sortingType}
             currentPage={currentPage}
             getRecievedGiftList={this.props.getRecievedGiftList}
             eventStatus={this.props.eventStatus}
             allMessages={this.props.allMessages}
             addAgain={this.addAgain}
             setAddAgainAlert={this.setAddAgainAlert}
             showMessagePopUp={this.props.showMessagePopUp}
             selectedTheme={this.props.selectedTheme}
            />
          }
          <div className="col-md-12">
           {(!listIsEmpty || !_.isEmpty(filterParamsReceivedGift) || !_.isEmpty(searchKeyword)) && ( 
            <div className="row invitedListGiftRegister">
            <div className="col-md-12 col-sm-12">
             {/*  <div className="col-md-2 col-sm-2">
                <div className="btn-group btnGroupGift">
                  <SelectionTab
                    classname="cSelect filters"
                    id="giftListModo"
                    options={SelectionOptions1.options}
                    optionCaption={
                      lables &&
                      commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.regalosrecibidos.mode.dropdown"
                      )
                    }
                    optionText={"option"}
                    optionValue={"option"}
                    isCaptionDisabled={false}
                    handleSelectedOption={(filter) =>
                      this.handleFilter("deliveryMode", filter.value)
                    }
                    disable={SelectionOptions1.length > 0}
                  />
                </div>
              </div>
              <div className="col-md-2 col-sm-2">
                <div className="btn-group btnGroupGift">
                  <SelectionTab
                    classname="cSelect filters"
                    id="giftListCategoría"
                    options={CategoryOptions.options}
                    optionCaption={
                      lables &&
                      commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.regalosrecibidos.category.dropdown"
                      )
                    }
                    optionText={"value"}
                    optionValue={"value"}
                    isCaptionDisabled={false}
                    handleSelectedOption={(filter) =>
                      this.handleFilter("category", filter.id)
                    }
                  />
                </div>
              </div>
              <div className="col-md-2 col-sm-2">
                <div className="btn-group btnGroupGift">
                  <SelectionTab
                    classname="cSelect filters"
                    id="giftListMensajes"
                    options={MessageInfo.options}
                    optionCaption={
                      lables &&
                      commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.regalosrecibidos.message.dropdown.label"
                      )
                    }
                    optionText={"option"}
                    optionValue={"option"}
                    isCaptionDisabled={false}
                    handleSelectedOption={(filter) =>
                      this.handleFilter("message", filter.value)
                    }
                    disable={MessageInfo.length > 0}
                  />
                </div>
              </div>
              <div className="col-md-2 col-sm-2">
                <div className="btn-group btnGroupGift">
                  {!this.props.compareEventStatus(
                    this.props.eventType,
                    eventTypes
                  ) ? (
                    <SelectionTab
                      classname="cSelect filters"
                      id="giftListBonificación"
                      options={BonusInfo.options}
                      optionCaption={
                        lables &&
                        commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.bonus.dropdown"
                        )
                      }
                      optionText={"option"}
                      optionValue={"option"}
                      isCaptionDisabled={false}
                      handleSelectedOption={(filter) =>
                        this.handleFilter("bonusApplicable", filter.value)
                      }
                      disable={BonusInfo.length > 0}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div> */}
              { (searchKeyword || totalRecords >0) && (
                <>
                  <div className="col-sm-4"></div>
                  <div className="col-md-4 col-sm-4 invitedListSearch buscarwrapper">
                    <div className="input-group">
                      <TextInput
                        className="form-control buscar-text"
                        htmlId="searchAreaForReceivedGifts"
                        placeholder={
                          lables &&
                          commonUtil.getLabel(
                            lables.EventAdminPage,
                            "adminpage.regalosrecibidos.search.message"
                          )
                        }
                        required="true"
                        star=""
                        ref={(txt) => (this.searchGift = txt)}
                        onKeyUp={this.onSearchAreaKeyUpForReceivedGifts}
                      />
                      <span className="input-group-btn">
                        {this.state.searchFlag ? (
                          <span
                            className="btn btn-default buttonSearch"
                            onClick={this.onClickSearchResult}
                          >
                            <i className="icon-zoom" aria-hidden="true" />
                          </span>
                        ) : (
                          <span
                            className="btn btn-default buttonSearch"
                            onClick={this.clearSearch}
                          >
                            <i className="iClass icon-tache2" aria-hidden="true" />
                          </span>
                        )}
                      </span>
                    </div>
                  </div>
                </>
              )}
              { totalRecords > 0 && (
              <>
                <div className="col-sm-4"></div>
                <div className="row">
                  <div className="col-xs-12 giftList-filters">
                  <div className="row">
                    <div className='col-xs-7'></div>
                    <div className="col-xs-4 pull-right sort-container">
                      <div className='giftList-sort-div'>
                        <div className='giftList-sort'>
                          <Link linkJSON={LinkJSONPrice}>
                            <InputButton buttonAttr={SortArticleButton} />
                          </Link>
                        </div>
                        <div className="giftList-sort-modal" style={{ display: 'none' }}>
                           {priceSorting.map((option, index) => (
                            <div key={index} id={option.id} onClick={() => handleSwitchRadio(option.id)} className={`sort-option ${this.sortType === option.id ? 'active' : ''}`}>
                              <span className="radio-icon" />
                              <span className="lable-txt">{option.value}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </>)}
            </div>
            </div>
           )}
          {!listIsEmpty && (
            <div className="col-xs-12 text-right giftList-total-records">
              <b>{totalRecordsShowed} de {totalReceivedGifts}</b> productos
            </div>
          )}
          {!listIsEmpty && (
            <div className="col-md-12 col-sm-12">
              <div className="tableReceivedGifts" id="receivedSection">

                <div className="gift-card-head">
                  <div className="row">
                    <div className="col-md-6 col-sm-6">
                      <div className="giftList-image">&nbsp;</div>
                      <div className="giftList-productDetails">
                        {commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosrecibidos.articulo.label")}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12 pl-0">
                      <div className="row">
                        <div className="col-sm-3 text-center">
                          <div>{commonUtil.getLabel(lables.EventAdminPage,"adminpage.regalosregistrados.price.label")}</div>
                        </div>
                        <div className="col-sm-9 pl-0">
                          <div>{commonUtil.getLabel(lables.EventAdminPage,"adminpage.comparas.purchase.label")}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
               {/*  <thead className="rowLines">
                  <tr>
                    <td className="headImgInner" />
                    <td className="textToLeft">Producto</td>
                    <td className="headPriceInner text-center">
                      <Link linkJSON={LinkJSONPrice}>
                        <span className="tooltip-container">
                          {lables &&
                            commonUtil.getLabel(
                              lables.EventAdminPage,
                              "adminpage.regalosrecibidos.price.label"
                            )}
                          <span className="tooltip-box">
                            {commonUtil.getLabel(
                              lables.EventAdminPage,
                              "adminpage.comparas.price.tooltip.label"
                            )}
                          </span>
                        </span>
                        &nbsp;
                        {this.sortType === "Descending" ? (
                          <i
                            className="icon-flecha_filtros_abajo"
                            aria-hidden="true"
                          />
                        ) : (
                          <i
                            className="icon-flecha_filtros_arriba"
                            aria-hidden="true"
                          />
                        )}
                      </Link>
                    </td>
                    <td className="headQuantityInner text-center">
                      <Link linkJSON={LinkJSON}>
                        {lables &&
                          commonUtil.getLabel(
                            lables.EventAdminPage,
                            "adminpage.regalosrecibidos.qty.label"
                          )}
                      </Link>
                    </td>
                    <td className="textToLeft headDetailInner">
                      <Link linkJSON={LinkJSON}>
                        {lables &&
                          commonUtil.getLabel(
                            lables.EventAdminPage,
                            "adminpage.regalosrecibidos.purchasedby.label"
                          )}
                      </Link>
                    </td>
                    {!this.props.compareEventStatus(
                      this.props.eventType,
                      eventTypes
                    ) ? (
                      <td className="headIconInner text-center tooltip-container">
                        <Link linkJSON={LinkJSON}>
                          {lables &&
                            commonUtil.getLabel(
                              lables.EventAdminPage,
                              "adminpage.regalosrecibidos.bonus.label"
                            )}
                        </Link>
                        <span className="tooltip-box">
                          {commonUtil.getLabel(
                            this.props.lables.EventAdminPage,
                            "adminpage.regalosrecibidos.bonus.label.tooltip"
                          )}
                        </span>
                      </td>
                    ) : (
                      ""
                    )}
                    <td className="headMessage text-center">
                      {lables &&
                        commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.message.label"
                        )}
                    </td>
                  </tr>
                </thead> */}
                {receivedItemsInfo && receivedItemsInfo.length > 0 ? (
                  <div>{html}</div>
                ) : (
                  <React.Fragment>
                    {this.searchedValue && this.searchedValue !== "" ? (
                      <p>
                        {commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.your.research.label"
                        )}{" "}
                        {this.searchedValue}{" "}
                        {commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.zero.results"
                        )}
                      </p>
                    ) : (
                      <p>
                        {commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.zero.search.results"
                        )}
                      </p>
                    )}
                  </React.Fragment>
                )}
              </div>
            </div>
          )}
          {listIsEmpty && <EmptyGiftListIndicator giftList={`${this.inititialReceivedItems.totalRecords == 0 ? 'received': 'received_noSearchResults'}`} style={{ padding: '3rem 0' }} />}
          <ModalPopover
            modalId="formMessageModal"
            isModal="true"
            ref={(modalfornone) => (this.modalfornone = modalfornone)}
          >
            <button
              id="closeModal"
              className="btnClose"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.handleCloseforNoneModal}
            >
              <i>×</i>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              {lables &&
                commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.thankyoumsg.label"
                )}
            </h4>
            <span className="requiredFields">
              {lables &&
                commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.msg.requirefields"
                )}
            </span>
            <form>
              <div className="formBlock">
                <TextInput
                  htmlId="textGuestNameNone"
                  className="inputMaterial"
                  star="*"
                  required="required"
                  labelClassName="placeHolderMaterial"
                  label={commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.msg.guestname"
                  )}
                />
              </div>
              <div className="formBlock">
                <div className="materialStyle">
                  <TextInput
                    htmlId="textGuestEmailNone"
                    star="*"
                    className="inputMaterial"
                    required="required"
                    labelClassName="placeHolderMaterial"
                    label={commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.msg.guestemail"
                    )}
                  />
                </div>
              </div>
              <div className="formgroup">
                <textarea
                  className="form-control"
                  type="text"
                  rows={6}
                  id="SendMessageforNone"
                  placeholder={commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.thankyoumsg.bcc.text"
                  )}
                  maxLength={300}
                />
              </div>
              <InputButton buttonAttr={sendThankyouMessageNoneButton} />
            </form>
          </ModalPopover>

          <ModalPopover
            modalId="messageModal"
            isModal="true"
            ref={(modalforReplied) => (this.modalforReplied = modalforReplied)}
          >
            <button
              id="closeModal"
              className="btnClose"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.handleCloseforRepliedModal}
            >
              <i>×</i>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              {lables &&
                commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.message.label"
                )}
            </h4>
            <div className="congratsMessage">
              <p>
                {this.props.messages && this.props.messages.customMsg
                  ? this.props.messages.customMsg
                  : null}
              </p>
            </div>
            <h4 className="modal-title" id="myModalLabel">
              {lables &&
                commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.thankyoumsg.label"
                )}
            </h4>
            <div className="congratsMessage">
              <p>
                {this.props.messages && this.props.messages.customerMsg
                  ? this.props.messages.customerMsg
                  : null}
              </p>
            </div>
          </ModalPopover>

          <ModalPopover
            modalId="messageModal"
            isModal="true"
            ref={(modalforNew) => (this.modalforNew = modalforNew)}
          >
            <button
              id="closeModal"
              className="btnClose"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.handleCloseforNewModal}
            >
              <i>×</i>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              {lables &&
                commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.message.label"
                )}
            </h4>
            <div className="congratsMessage">
              <p>
                {this.props.messages && this.props.messages.customMsg
                  ? this.props.messages.customMsg
                  : null}
              </p>
            </div>
            <h4 className="modal-title" id="myModalLabel">
              {lables &&
                commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.thankyoumsg.label"
                )}
            </h4>

            {!this.props.messages.guestEmail ||
            this.props.messages.guestEmail === "" ? (
              <React.Fragment>
                <span className="requiredFields">
                  {lables &&
                    commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.msg.requirefields"
                    )}
                </span>
                <form>
                  <div className="formBlock">
                    <TextInput
                      htmlId="textGuestNameNew"
                      className="inputMaterial"
                      star="*"
                      required="required"
                      labelClassName="placeHolderMaterial"
                      label={commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.regalosrecibidos.msg.guestname"
                      )}
                    />
                  </div>
                  <div className="formBlock">
                    <div className="materialStyle">
                      <TextInput
                        htmlId="textGuestEmailNew"
                        star="*"
                        className="inputMaterial"
                        required="required"
                        labelClassName="placeHolderMaterial"
                        label={commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.msg.guestemail"
                        )}
                      />
                    </div>
                  </div>
                  <div className="formgroup">
                    <textarea
                      className="form-control"
                      type="text"
                      rows={6}
                      id="textArea1"
                      placeholder={commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.regalosrecibidos.thankyoumsg.bcc.text"
                      )}
                      maxLength={300}
                    />
                  </div>
                  <InputButton buttonAttr={sendThankyouMessageNewButton} />
                </form>{" "}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="form-group">
                  <textarea
                    id="textArea1"
                    className="form-control"
                    rows={6}
                    placeholder={commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.thankyoumsg.bcc.text"
                    )}
                    maxLength={300}
                  />
                </div>
                <InputButton buttonAttr={sendThankyouMessageNewButton} />{" "}
              </React.Fragment>
            )}
          </ModalPopover>

          <ModalPopover
            modalId="messageModal"
            isModal="true"
            ref={(modalforOpen) => (this.modalforOpen = modalforOpen)}
          >
            <button
              id="closeModal"
              className="btnClose"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.handleCloseforOpenModal}
            >
              <i>×</i>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              {lables &&
                commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.message.label"
                )}
            </h4>
            <div className="congratsMessage">
              <p>
                {this.props.messages && this.props.messages.customMsg
                  ? this.props.messages.customMsg
                  : null}
              </p>
            </div>
            <h4 id="myModalLabel" className="mb0">
              {lables &&
                commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.thankyoumsg.label"
                )}
            </h4>

            {!this.props.messages.guestEmail ||
            this.props.messages.guestEmail === "" ? (
              <React.Fragment>
                <span className="requiredFields">
                  {lables &&
                    commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.msg.requirefields"
                    )}
                </span>
                <form>
                  <div className="formBlock">
                    <TextInput
                      htmlId="textGuestNameOpen"
                      className="inputMaterial"
                      required="required"
                      star="*"
                      labelClassName="placeHolderMaterial"
                      label={commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.regalosrecibidos.msg.guestname"
                      )}
                    />
                  </div>
                  <div className="formBlock">
                    <div className="materialStyle">
                      <TextInput
                        htmlId="textGuestEmailOpen"
                        className="inputMaterial"
                        star="*"
                        required="required"
                        labelClassName="placeHolderMaterial"
                        label={commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.msg.guestemail"
                        )}
                      />
                    </div>
                  </div>
                  <div className="formgroup">
                    <textarea
                      className="form-control"
                      type="text"
                      rows={6}
                      id="sendMessage"
                      placeholder={commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.regalosrecibidos.thankyoumsg.bcc.text"
                      )}
                      maxLength={300}
                    />
                  </div>
                  <InputButton buttonAttr={sendThankyouMessageOpenButton} />
                </form>{" "}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    type="text"
                    rows={6}
                    id="sendMessage"
                    placeholder={commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.thankyoumsg.bcc.text"
                    )}
                    maxLength={300}
                  />
                </div>
                <InputButton buttonAttr={sendThankyouMessageOpenButton} />
              </React.Fragment>
            )}
          </ModalPopover>

          <ModalPopover
            ref={(noneRepliedModal) =>
              (this.noneRepliedModal = noneRepliedModal)
            }
            modalId="thanksMessageModal"
            isModal="true"
          >
            <button
              id="closeModal"
              className="btnClose"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i>×</i>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              {lables &&
                commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.thankyoumsg.label"
                )}
            </h4>
            <div className="congratsMessage">
              <p>
                {lables &&
                  commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.sentto.lable"
                  )}{" "}
                {this.props.messages && this.props.messages.guestEmail}
              </p>
            </div>
            <p>
              {this.props.messages && this.props.messages.customerMsg
                ? this.props.messages.customerMsg
                : null}
            </p>
          </ModalPopover>
        </div>
        </div>
        {/* modal popover for tracker */}
        <ModalPopover
          modalId="tracingModal"
          isModal="true"
          ref={(trackerModal) => (this.trackerModal = trackerModal)}
        >
          <button
            id="closeModal"
            className="btnClose"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <i>×</i>
          </button>
          <h4>
            {lables &&
              commonUtil.getLabel(
                lables.EventAdminPage,
                "adminpage.regalosrecibidos.delivery.tracking.label"
              )}
          </h4>
          <div className="row">
            <div className="headerTracing">
              <div className="col-md-3 col-sm-3 contentTracing">
                <p className="titleTracing">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.trackorder.purchase.date.label"
                  )}
                </p>
                <p className="subTracing textToBold">
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.dateOfPurchase
                    ? commonUtil.formatDate(
                        commonUtil.formatServiceDate(
                          trackInfo.orderTrackInfo.dateOfPurchase
                        ),
                        "monthName"
                      )
                    : ""}
                </p>
              </div>
              <div className="col-md-2 col-sm-3 contentTracing">
                <p className="titleTracing">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.trackorder.total.label"
                  )}
                </p>
                <p className="subTracing priceTag">{trackInfoPrice}</p>
              </div>
              <div className="col-md-2 col-sm-3 contentTracing">
                <p className="titleTracing">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.trackorder.sendto.label"
                  )}
                </p>
                <p className="subTracing textToBold">
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.boughtFor
                    ? trackInfo.orderTrackInfo.boughtFor
                    : this.giftData &&
                      this.giftData.guestInfo.popupOwner &&
                      this.giftData.guestInfo.popupOwner}
                </p>
              </div>
              <div className="col-md-2 col-sm-3 contentTracing">
                <p className="titleTracing">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.trackorder.event.label"
                  )}
                </p>
                <p className="subTracing textToBold">{this.props.eventId}</p>
              </div>
              <div className="col-md-3 col-sm-3 contentTracing orderRequest">
                <p className="titleTracing">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.trackorder.orderno.label"
                  )}
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.pedidoNo
                    ? trackInfo.orderTrackInfo.pedidoNo
                    : ""}
                </p>
              </div>
            </div>
            <div className="col-md-12 col-sm-12">
              <div className="col-md-2 col-sm-2">
                <Image imageAttr={imageAttrTracker} />
              </div>
              <div className="col-md-10 col-sm-10">
                <p className="nameProduct textToBold">
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.productName
                    ? trackInfo.orderTrackInfo.productName
                    : ""}
                </p>
                <p className="quantity subOrder">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.qty.label"
                  )}
                  :{" "}
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.quantity
                    ? parseInt(trackInfo.orderTrackInfo.quantity, 10)
                    : this.giftData.quantity}
                </p>
                <div className="progress progressBar">
                  <div
                    className="progress-bar progress-bar-info"
                    ref={(barWidht) => (this.barWidht = barWidht)}
                  >
                    <ProgressBar
                      percent={this.progressBar}
                      width={560}
                      height={20}
                    />
                  </div>
                </div>
                <div className="col-md-3 col-sm-3 pl-0">
                  <p className={this.stage1class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage1Status
                      ? trackInfo.orderTrackInfo.stage1Status
                      : ""}
                    <i className="icon-caret_down tooltip-container">
                      <span className="tooltip-box">
                        {commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.trackorder.confirmed.order.tooltip"
                        )}
                      </span>{" "}
                    </i>
                  </p>
                  <p className="subOrder textToBold">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage1Date
                      ? commonUtil.getLabel(
                          lables.EventAdminPage,
                          trackInfo.orderTrackInfo.stage1Date
                        )
                      : ""}
                  </p>
                </div>
                <div className="col-md-3 col-sm-3 pl-0">
                  <p className={this.stage2class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage2Status
                      ? trackInfo.orderTrackInfo.stage2Status
                      : ""}
                    <i className="icon-caret_down tooltip-container">
                      <span className="tooltip-box">
                        {commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.trackorder.preparing.tooltip"
                        )}
                      </span>{" "}
                    </i>
                  </p>
                  <p className="subOrder textToBold">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage2Date
                      ? trackInfo.orderTrackInfo.stage2Date
                      : ""}
                  </p>
                </div>
                <div className="col-md-3 col-sm-3 pl-0">
                  <p className={this.stage3class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage3Status
                      ? trackInfo.orderTrackInfo.stage3Status
                      : ""}
                    <i className="icon-caret_down tooltip-container">
                      <span className="tooltip-box">
                        {commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.trackorder.ontheway.tooltip"
                        )}
                      </span>{" "}
                    </i>
                  </p>
                  <p className="subOrder textToBold">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage3Date
                      ? trackInfo.orderTrackInfo.stage3Date
                      : ""}
                  </p>
                </div>
                <div className="col-md-3 col-sm-3 pl-0">
                  <p className={this.stage4class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage4Status
                      ? trackInfo.orderTrackInfo.stage4Status
                      : ""}
                    <i className="icon-caret_down tooltip-container">
                      <span className="tooltip-box">
                        {" "}
                        {commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.regalosrecibidos.trackorder.delivered.tooltip"
                        )}{" "}
                      </span>{" "}
                    </i>
                  </p>
                  <p className="subOrder textToBold">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage4Date
                      ? trackInfo.orderTrackInfo.stage4Date
                      : ""}
                  </p>
                </div>
              </div>
            </div>
            {trackInfo &&
            trackInfo.orderTrackInfo &&
            trackInfo.orderTrackInfo.trackingNumber !== "" ? (
              <div className="col-md-12 col-sm-12 footerTlo">
                <p>
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.shipping.dhl.by.label"
                  )}{" "}
                  -{" "}
                  <span>
                    {commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.guide.number.by.label"
                    )}
                    :{" "}
                    <a href={trackOrderURL}>
                      {trackInfo &&
                      trackInfo.orderTrackInfo &&
                      trackInfo.orderTrackInfo.trackingNumber
                        ? trackInfo.orderTrackInfo.trackingNumber
                        : ""}
                    </a>
                  </span>
                </p>
                {/* <i className="fa fa-angle-right" onClick={this.trackOrderLink} /> */}
              </div>
            ) : null}
          </div>
        </ModalPopover>
        <ModalPopover
          modalId="modalDelete"
          outerClass="modal-sm"
          isModal="true"
          ref={(failureTrackingModal) =>
            (this.failureTrackingModal = failureTrackingModal)
          }
          handleOutsideClick
          header
        >
          <div className="row text-align-center mb10">
            <div className="col-xs-12">
              <p>
                {commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.recibidos.track.order.failure.message"
                )}
              </p>
            </div>
            <div className="col-sm-12">
              <button
                className="btnSecondaryAction size-Small"
                value="cancel"
                onClick={this.dismissDelete}
              >
                OK
              </button>
            </div>
            {/* </div> */}
          </div>
        </ModalPopover>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  allMessages: state.giftList.data.allMessagesInfo,
  messages: state.giftList.data.messageInfo,
  messageLoaded: state.giftList.messageLoaded,
  trackOrderInfo: state.giftList.data.trackOrderInfo,
  eventStatus:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo.eventStatus,
  eventType:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo.eventType,
  eventInfo: state.giftList?.data?.eventSummaryInfo?.eventInfo || {},
  registeredGiftListPriceOrder: state.giftList.data.registeredGiftList?.originalRegisteredGiftList?.priceOrder || 'Ascending',
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMessagesService,
      getAllMessagesService,
      getTrackOrder,
      getRegisteredGiftList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(RegalosRecibidosContent);
